var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.styleClass + ' ' + _vm.sizeClass() + ' btn btn-default',attrs:{"type":"button"},on:{"click":function($event){return _vm.addSparkToMyDreams(_vm.spark)}}},[_c('PlusIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }